import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollToProducts = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const element = document.getElementById('products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('products');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/b0fdc4e391d0a3ab43ffd053ddd167ff.jpg" 
            alt="AlienProduction Logo" 
            className="w-8 h-8 rounded-full object-cover transition-transform group-hover:scale-110"
          />
          <span className="text-xl font-bold tracking-tight text-zinc-950">
            AlienProduction
          </span>
        </Link>

        <nav className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-6">
            <Link 
              to="/#products" 
              onClick={handleScrollToProducts}
              className="text-sm font-medium text-zinc-600 hover:text-zinc-950 transition-colors"
            >
              Templates
            </Link>
            <Link 
              to="/resources" 
              className={`text-sm font-medium transition-colors ${location.pathname === '/resources' ? 'text-zinc-950' : 'text-zinc-600 hover:text-zinc-950'}`}
            >
              Resources
            </Link>
            <Link 
              to="/blog" 
              className={`text-sm font-medium transition-colors ${location.pathname.startsWith('/blog') ? 'text-zinc-950' : 'text-zinc-600 hover:text-zinc-950'}`}
            >
              Blog
            </Link>
          </div>

          <a 
            href="https://alienproduction.etsy.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group flex items-center gap-2 bg-zinc-950 text-white px-5 py-2.5 rounded-md font-medium text-sm transition-all hover:bg-zinc-800 focus:ring-2 focus:ring-zinc-950 focus:ring-offset-2"
          >
            Visit Etsy Shop
            <SafeIcon icon={FiExternalLink} className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;